<template>
    <div class="h-100">
        <div v-if="!isBrowserIE" class="back-off h-100">
            <topbar
                :style="moduleSwitcher.width > 0 ? `margin-left: ${moduleSwitcher.width}px !important` : ''"
                :home="{ name: 'campaigns.home' }"
                :isSidebarCollapsed="isSidebarCollapsed"
                :restaurants="restaurants"
                :user="user"
                module_type="campaigns"
                @module-switcher-button-clicked="moduleSwitcher.show = !moduleSwitcher.show"
                :mobileMenuDisplayed="mobileMenuDisplayed"
                @mobile-menu-updated="mobileMenuDisplayed = $event">
            </topbar>

            <div class="container-fluid h-100" :style="moduleSwitcher.show == true ? 'overflow-x: hidden;' : ''">
                <div class="row h-100">
                    <module-switcher
                        serviceId="campaigns"
                        :isSidebarCollapsed="isSidebarCollapsed"
                        :user="user"
                        @open="onModuleSwitcherOpen"
                        @close="closeModuleSwitcher"
                        :show="moduleSwitcher.show" />
                    <sidebar
                        :style="moduleSwitcher.width > 0 ? `margin-left: ${moduleSwitcher.width}px !important` : ''"
                        :user="user"
                        :restaurants="restaurants"
                        :isSidebarCollapsed="isSidebarCollapsed"
                        :entries="sidebarEntries"
                        :restaurantRouteName="`campaigns.restaurants.campaigns`"
                        @sidebar-collapse-changed="isSidebarCollapsed = $event"
                        @close-menu="mobileMenuDisplayed = false"
                        @reload-router-view="$emit('reload-router-view')">
                    </sidebar>

                    <main
                        role="main"
                        class="ps-0 pe-0 h-100 main"
                        :style="moduleSwitcher.width > 0 ? `margin-left: ${moduleSwitcher.width + 240}px !important` : ''"
                        :class="{
                            'col-md-12 col-lg-12': user && user.role === 'kitchen',
                            'offset-md-3 offset-lg-2 col-md-9 col-lg-10': user && user.role !== 'kitchen' && !isSidebarCollapsed,
                            'offset-md-1 offset-lg-1 col-lg-11 col-md-11': isSidebarCollapsed,
                        }">
                        <notifications style="z-index: 9999" group="notification" />

                        <slot />
                    </main>
                </div>
            </div>
            <AcceptCgvModal :module="MODULE_TYPE_CAMPAIGNS" v-if="showAcceptCgvModal" @close="showAcceptCgvModal = false" />
        </div>
        <div v-else style="text-align: center">
            <h1>Navigateur non supporté</h1>
            <p v-html="$t('errors.browser.invalid.infos')"></p>
            <br />
        </div>
    </div>
</template>

<script>
import axios from "axios";
// load components
import Sidebar from "../Sidebar.vue";
import Topbar from "../Topbar.vue";
import ModuleSwitcher from "../ModuleSwitcher";
import ModuleTypesEnum from "../../mixins/enums/ModuleTypesEnum";
import AcceptCgvModal from "../../components/Modals/CGU/AcceptCgvModal";

export default {
    props: {
        user: {
            required: true,
        },
    },
    data: function () {
        return {
            submenu: false,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
            selected_service_id: null,
            servicesNavbar: false,
            creditCountSms: null,
            smsActivated: null,
            isSidebarCollapsed: this.isSidebarCollapsedTablet(),
            moduleSwitcher: {
                show: false,
                height: 0,
                width: 0,
            },
            mobileMenuDisplayed: false,
            showAcceptCgvModal: false,
        };
    },
    mixins: [ModuleTypesEnum],
    computed: {
        restaurant_id() {
            return this.$route.params.restaurant_id;
        },
        sidebarEntries() {
            return [
                {
                    to: { name: "campaigns.restaurants.campaigns" },
                    title: "Campagnes",
                    icon: "mail",
                    exactUrlMatching: false,
                    rights: ["campaigns.*"],
                },
                {
                    to: { name: "campaigns.clients" },
                    title: "Clients",
                    icon: "users",
                    exactUrlMatching: false,
                    rights: ["default.customer.*"],
                },
            ];
        },
        restaurants() {
            return this.$store.getters["restaurants/getRestaurantsByService"]("campaigns");
        },
        isOwner() {
            return this.$store.getters["users/role"] === "owner";
        },
    },
    methods: {
        isSidebarCollapsedTablet() {
            if (window.innerWidth <= 1024 && window.innerWidth > 767) {
                return true;
            } else {
                return false;
            }
        },
        onModuleSwitcherOpen({ width, height }) {
            this.moduleSwitcher.width = width;
            this.moduleSwitcher.height = height;
        },
        closeModuleSwitcher() {
            this.moduleSwitcher.width = 0;
            this.moduleSwitcher.height = 0;
            this.moduleSwitcher.show = false;
        },
        logout() {
            axios
                .post("/logout")
                .then((response) => {
                    window.location.replace(response.data.redirect_url || response.headers.location || "/login");
                })
                .catch(() => {});
        },
        selectRestaurant(event) {
            this.$router.push({
                name: "campaigns.restaurants.campaigns",
                params: { restaurant_id: event.target.value },
            });
        },
        fetchHasAcceptedCgvs() {
            this.loading = true;

            return axios
                .get(`/api/accepted_cgvs/modules/${this.MODULE_TYPE_CAMPAIGNS.value}`)
                .then((response) => {
                    this.loading = false;
                    this.showAcceptCgvModal = !response.data.result;
                })
                .catch(() => (this.loading = false));
        },
    },
    components: {
        Sidebar,
        Topbar,
        ModuleSwitcher,
        AcceptCgvModal,
    },
    created() {
        if (this.isOwner) this.fetchHasAcceptedCgvs();
    },
};
</script>
